// Third-party Library
import { useState } from "react";
import { Table, Input, Form, Select, message , Space, Tag, Button} from "antd";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";

// Constants
import { TEMPLATE, COMMON_FEATURES, ROUTES } from "../../../../../../constants";

// Components
import { ButtonLink, BtnSubmit, Options} from "../../../../../../components";

import { REDUX as REDUX_UTIL } from "../../../../../../services/util";

import * as REDUX_ACTION from "../../../../../../services/redux/actions";

import { bulkUploadHDLR } from "../../../../../../handlers";

//style 

const { reduxStoreWrapper } = REDUX_UTIL;
const { BULK_UPLOAD_REVIEW_COLUMN } = TEMPLATE.TABLEDATA.EMPLOYEE;
const { TABLE_BULK_UPLOAD_INDEX_EMPTY_STRINGS} = TEMPLATE.EMPLOYEE;

const ReviewTemplate = ({ srcData, setSrcData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const user = useSelector(reduxStoreWrapper("user"))
  const employees = Object.values(useSelector(reduxStoreWrapper("employee.byID")))
  const company = useSelector(reduxStoreWrapper("company.byID"))

  const [editingKey, setEditingKey] = useState("");

  // check condition whether the selected record key matched with editingKey
  const isEditing = (record) => record.key === editingKey;

  /**
   *
   * in-table CRUD Functions
   *
   */

  const add = () => {
    // set new column with empty input fields
    const objWithEmptyStrings = TABLE_BULK_UPLOAD_INDEX_EMPTY_STRINGS;
    const highestKey = Math.max(...srcData.map(data => data.key), 0);
    const newData = {
      ...objWithEmptyStrings,
      key: highestKey + 1,
      isNew: true,
    };

    setEditingKey(newData.key);
    setSrcData([newData, ...srcData]);
  };

  const edit = (record) => {
    const coid = record.coid && `${record.coid}/ ${record.company_name}`
    form.setFieldsValue({...record, coid: coid});
    setEditingKey(record.key);
  };

  const remove = (record) => {
    const newArray = srcData.filter((data) => data.key !== record.key);
    setSrcData(newArray);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = () => {
    const formData = form.getFieldsValue()
    const contact = (formData?.contact || "").replace(/[\s-]/g, '');
    const company = formData?.coid?.split("/")

    const newData = {
      ...formData,
      key: editingKey,
      contact: contact,
      coid: company[0],
      company_name: company[1] || ""
    };

    const newSrcData = srcData.map((data) => {
      const newItem = { ...data, ...newData }
      delete newItem.reasonMessages
      delete newItem.isNew
      return data.key === editingKey ? newItem : data
      }
    );
    setSrcData(newSrcData);
    setEditingKey("");
    form.resetFields();
  };

  const failReasonMsgHDLR = (record) =>  bulkUploadHDLR.failReasonUser(record, srcData, employees, company)

  const columns = [
    ...BULK_UPLOAD_REVIEW_COLUMN(),
    {
      title: "Fail Reasons",
      key: "Fail Reasons",
      editable: false,
      render: (record) => {
        const msg = failReasonMsgHDLR(record);

        return msg?.map((m) => <div style={{ color: "red" }}>{m}</div>);
      },
    },
    {
      title: "Actions",
      fixed: "right",
      render: (record) => {
        const editable = isEditing(record);

        return (
          <div style={{ display: "flex", gap: "6px" }}>
            {editable ? (
              <>
                <ButtonLink onClick={save}>Save</ButtonLink>
                <ButtonLink onClick={cancel}>Cancel</ButtonLink>
              </>
            ) : (
              <>
                <ButtonLink onClick={() => edit(record)}>Edit</ButtonLink>
                <ButtonLink onClick={() => remove(record)}>Remove</ButtonLink>
              </>
            )}
          </div>
        );
      },
    },
  ];

  // columns to render the edit input field (and not to do)
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    if (col.key === "Fail Reasons") {
      return; 
    }

    return {
      ...col,
      onCell: (record) => ({
          record,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
      }),
    };
  });

  const mergedColumnsSuccess = mergedColumns.filter((_, i) => i !== 12);

  const EditableCell = ({ editing, dataIndex, children, record, ...restProps }) => {
    const colKey = dataIndex === undefined ? 'coid' : dataIndex
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item name={colKey} style={{ margin: 0 }}>
          {(() => {
            switch (colKey) {
              case 'bank_name':
                return (
                  <Select>
                    {Options.bankList.map((option) => (
                    <Option
                      key={option.value.name} 
                      value={option.value.name}
                    >
                      {option.label}
                    </Option>
                  ))}</Select>
                );
              default:
                return <Input />;
            }
          })()}
        </Form.Item>        
        ) : (
          children
        )}
      </td>
    );
  };

  console.log(employees)
  
  const dataFail = bulkUploadHDLR.dataFailUser(srcData, employees, company)

  const dataSuccess = srcData.filter((data) => !dataFail.includes(data));

  const backHDLR = () => {
    navigate(
      ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.EMPLOYEE]
    );
  };

  const submitHDLR = () => {
    const newData = dataSuccess.map(d => {
      const { key, ...rest } = d; // Destructure to exclude key and company_name
      return { ...rest }; 
    });

      const items = {
        coid: user?.coid,
        createdBy: user?.uid,
        employees: newData
      }

    if (newData.length && dataFail.length === 0) {
        messageApi.open({
          type: "loading",
          content: "Creating employee...",
          duration: 0,
        });
  
      dispatch(REDUX_ACTION.v1_employee.bulk_upload_employee_request(items, ({ status, data }) => {
        messageApi.destroy();
        if(status ===  200){
          backHDLR()
        } else if(status === 207) {
          setSrcData(data.map((a, i) => ({...a, key: i})))
        }
      }))
    } else if(srcData.length === 0){
      message.error("No data available to submit");
    } else if(dataFail.length){
      message.error("There are still some issues in the failed table that need to be fixed");
    }
  };

  const operations = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: ".5em",
      }}
    >
      <div style={{textAlign: "left"}}>
        <h1>View Summary</h1>
        <p>Check your summary before uploading.</p>
      </div>
      <div>
        <BtnSubmit
          display="inline-block"
          text="Create"
          bgColor={dataFail.length ? "#A4A4A4" : "#0E2483"}
          color="white"
          padding="9px 18px"
          border="0"
          onClick={submitHDLR}
          disabled={dataFail.length}
        />
        <BtnSubmit
          display="inline-block"
          text="Cancel"
          bgColor="transparent"
          color="#A4A4A4"
          padding="9px 18px"
          border="1px solid #A4A4A4"
          onClick={backHDLR}
        />
      </div>
    </div>
  );

  return (
    <Form form={form} component={false}>
      {contextHolder}
      <div style={{ margin: "0 5em" }}>
        {operations}
        {(dataFail.length && (
          <>
            <Tag color="error" style={{ margin: "1em 0" }}>
              <CloseCircleFilled style={{ marginRight: "5px" }} />
              Failed ({dataFail.length})
            </Tag>
            <Table
              className="custom-table"
              columns={mergedColumns.map((c) => ({
                ...c,
                textWrap: "word-break",
                ellipsis: true,
              }))}
              dataSource={dataFail}
              pagination={false}
              scroll={{ x: true }}
              components={{ body: { cell: EditableCell } }}
            />
          </>
        )) ||
          ""}
        {/* {(dataSuccess.length && ( */}
          <>
            <Space style={{width: "100%", justifyContent: "space-between"}}>
              <Tag color="success" style={{ margin: "2em 0 1em 0" }}>
                <CheckCircleFilled style={{ marginRight: "5px" }} />
                Ready for uploading ({dataSuccess.length})
              </Tag>
              <Button onClick={() => add()}>Add</Button>
            </Space>
            <Table
              className="custom-table"
              columns={mergedColumnsSuccess.map((c) => ({
                ...c,
                textWrap: "word-break",
                ellipsis: true,
              }))}
              dataSource={dataSuccess}
              pagination={false}
              scroll={{ x: true }}
              components={{ body: { cell: EditableCell } }}
            />
          </>
        {/* )) || ""} */}
      </div>
    </Form>
  );
};

export default ReviewTemplate;
